import React from 'react'

import { SvgProps } from '../../model/types'

const CheckIcon: React.FC<SvgProps> = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="currentColor"
			{...props}
		>
			<path
				fillRule="evenodd"
				d="M16.504 6.137l-8.288 8.462c-.216.221-.565.22-.78-.003l-3.943-4.092c-.214-.222-.213-.582.003-.802l.392-.4c.216-.22.565-.219.779.004l3.167 3.286L15.34 4.93c.217-.221.565-.22.78.003l.388.402c.214.223.213.582-.003.803z"
			/>
		</svg>
	)
}

export default CheckIcon
